import axios from 'axios'

export default {
	detectors(token, showDeleted) {
		const headers = {};		
		var options={};
		
		if (token)
			headers.authorization='Bearer ' + token;
		if (showDeleted)
			options.showdeleted=showDeleted;
		return axios.post('/tract/api/detectors', options, {headers:headers});
	},	
	addDetector(detector, token) {
		const options = {
		};		
		if (token)
			options.authorization='Bearer ' + token;
		return axios.post('/tract/api/detector/new', detector, {headers:options});
	},		
	updateDetector(detector, token) {
		const options = {
		};		
		if (token)
			options.authorization='Bearer ' + token;
		return axios.post('/tract/api/detector/update', detector, {headers:options});
	},		
	deleteDetector(id, token) {
		const options = {
		};		
		if (token)
			options.authorization='Bearer ' + token;
		return axios.post('/tract/api/detector/delete', {id:id}, {headers:options});
	},		
}	